import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { ToggleEl } from "common/components/toggle";
import { LiftComparisonEl } from "common/widgets/lift-comparison-menu";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-controls"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-report-controls"
  }, this.attr(`show-date-range-selector`) ? this.helpers.dateRangeSelectorRenderer() : null, this.showLiftComparison() && /* @__PURE__ */ jsx(LiftComparisonEl, {
    attrs: {
      "max-data-history-days": this.attr(`max-data-history-days`),
      "selected-date": this.attr(`comparison-date-range`),
      "date-range": this.attr(`date-range`),
      "project-id": this.attr(`project-id`),
      breakdowns: this.attr(`breakdowns`),
      "selected-breakdown-segments": this.attr(`selected-breakdown-segments`),
      "workspace-id": this.attr(`workspace-id`),
      "project-as-of-date": this.attr(`project-as-of-date`),
      "selected-lift-comparison": this.attr(`selected-lift-comparison`),
      "time-comparison-disabled-reason": this.attr(`time-comparison-disabled-reason`),
      "lift-type-overrides": this.attr(`lift-type-overrides`),
      elref: `liftComparisonMenu`
    },
    on: {
      select: this.helpers.updateLiftComparison,
      remove: this.helpers.removeLiftComparison
    }
  }), this.helpers.hasSlot(`report-controls`) ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-report-controls-slot-container"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `report-controls` }
  })) : null), /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-chart-controls"
  }, this.helpers.hasSlot(`chart-controls`) ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item.for-slot"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `chart-controls` }
  })) : null, this.attr(`value-representations`).length ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    key: "value-representation-selector",
    attrs: this.helpers.valueRepresentationSelectorAttributes(),
    on: {
      select: this.helpers.updateValueRepresentation
    }
  })) : null, this.attr(`chart-viz-types`).length ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    sel: ".chart-viz-selector",
    attrs: this.helpers.getChartVizSelectorAttrs(),
    on: {
      select: this.helpers.updateChartVizType
    }
  })) : null, this.helpers.hasSlot(`date-unit-selector`) ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item.for-slot"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `date-unit-selector` }
  })) : this.attr(`date-units`).length ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item"
  }, /* @__PURE__ */ jsx(SelectEl, {
    key: "date-unit-selector",
    attrs: this.helpers.dateUnitSelectorAttributes(),
    on: {
      change: this.helpers.updateDateUnit
    }
  })) : null, this.attr(`chart-types`).length ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item"
  }, /* @__PURE__ */ jsx(SelectEl, {
    key: "chart-type-selector",
    attrs: this.helpers.chartSelectorAttributes(),
    on: {
      change: this.helpers.updateChartType
    },
    props: {
      contextPanelTransform: this.helpers.contextPanelTransform
    }
  })) : null, this.helpers.hasSlot(`advanced-chart-controls`) ? /* @__PURE__ */ jsx("div", {
    sel: ".chart-header-control-item.for-slot"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `advanced-chart-controls` }
  })) : null)));
}
